export const applyImpressionismStyle = async (canvas, ctx, setMessage, language) => {
  // 인상주의: 밝은 색채와 빠른 붓터치 느낌
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 밝고 생생한 색채 강화
  for (let i = 0; i < data.length; i += 4) {
    // 채도 증가
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    data[i] = Math.min(255, avg + (data[i] - avg) * 1.4);
    data[i + 1] = Math.min(255, avg + (data[i + 1] - avg) * 1.4);
    data[i + 2] = Math.min(255, avg + (data[i + 2] - avg) * 1.4);
    
    // 전체적으로 밝게 (인상주의의 밝은 팔레트)
    data[i] = Math.min(255, data[i] * 1.1 + 15);
    data[i + 1] = Math.min(255, data[i + 1] * 1.1 + 15);
    data[i + 2] = Math.min(255, data[i + 2] * 1.1 + 15);
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 빠른 붓터치 효과
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const brushData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const brushPixels = brushData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 붓터치 패턴 생성
  for (let y = 0; y < canvas.height; y += 4) {
    for (let x = 0; x < canvas.width; x += 4) {
      // 작은 영역의 평균 색상 계산
      let avgR = 0, avgG = 0, avgB = 0;
      let count = 0;
      
      for (let dy = 0; dy < 4 && y + dy < canvas.height; dy++) {
        for (let dx = 0; dx < 4 && x + dx < canvas.width; dx++) {
          const pos = ((y + dy) * canvas.width + (x + dx)) * 4;
          avgR += tempData[pos];
          avgG += tempData[pos + 1];
          avgB += tempData[pos + 2];
          count++;
        }
      }
      
      avgR /= count;
      avgG /= count;
      avgB /= count;
      
      // 붓터치 영역에 색상 적용 (약간의 변화 추가)
      for (let dy = 0; dy < 4 && y + dy < canvas.height; dy++) {
        for (let dx = 0; dx < 4 && x + dx < canvas.width; dx++) {
          const pos = ((y + dy) * canvas.width + (x + dx)) * 4;
          const variation = (Math.random() - 0.5) * 20;
          
          brushPixels[pos] = Math.min(255, Math.max(0, avgR + variation));
          brushPixels[pos + 1] = Math.min(255, Math.max(0, avgG + variation));
          brushPixels[pos + 2] = Math.min(255, Math.max(0, avgB + variation));
        }
      }
    }
  }
  
  ctx.putImageData(brushData, 0, 0);
  
  // 3. 색상 혼합 효과
  const blendData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const blendPixels = blendData.data;
  
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      if (Math.random() > 0.9) { // 10% 확률로 색상 혼합
        for (let c = 0; c < 3; c++) {
          const current = brushPixels[pos + c];
          const neighbor = brushPixels[((y + (Math.random() > 0.5 ? 1 : -1)) * canvas.width + x) * 4 + c];
          blendPixels[pos + c] = (current + neighbor) / 2;
        }
      }
    }
  }
  
  ctx.putImageData(blendData, 0, 0);
};